import { createBaseUserActionEvent } from './base';

export const UserActionsMixpanelEvents = {
    clickedOnTranslationButton: createBaseUserActionEvent,
    clickedOnCancelledTranslationButton: createBaseUserActionEvent,
};
